import { match } from 'ts-pattern';

import CONTACT_TYPES from 'lib/common/constants/contactTypes';

import getTaskType from '../../../contexts/ContactContext/utils/getTaskType';
import { getAgentVoiceOrChatConnection } from '../../conferenceConnections';
import connectGetter from '../../connectGetter';
import getContactConnection from '../../getContactConnection';

export default function isAgentMonitoring(contact: connect.Contact | undefined) {
  const contactType = getTaskType(contact);
  const doesTaskTypeSupportMonitoring = match(contactType)
    .with(
      CONTACT_TYPES.CALL,
      CONTACT_TYPES.QUEUE_CALLBACK,
      CONTACT_TYPES.CONFERENCE_CALL,
      CONTACT_TYPES.CHAT,
      () => true
    )
    .otherwise(() => false);

  if (!doesTaskTypeSupportMonitoring) {
    return false;
  }

  const agentConnection = getAgentVoiceOrChatConnection(contact);

  return (
    // When advanced monitoring is disabled/barge disabled
    getContactConnection(contact)?.getType() === connect.ConnectionType.MONITORING ||
    // When advanced monitoring is enabled
    connectGetter(agentConnection, 'getMonitorStatus') === connect.MonitoringMode.SILENT_MONITOR
  );
}
